import { CAT_TOKEN, IS_DEV_ENV, REFURB_TOKEN, catClient, clientV2 } from "..";
import { FONT_FAMILY, THEME_COLORS } from "@common/themes";
import {
  REMOVE_FIREBASE_TOKEN,
  SET_FIREBASE_TOKEN,
} from "@common/graphqlQueries/queries";
import React, { useEffect, useRef, useState } from "react";
import {
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { countQuery, countQueryForRefurb } from "@common/notificationCount";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { MaterialCommunityIcons } from "@expo/vector-icons";
import { initializeApp } from "firebase/app";
import moment from "moment";
import { toCamelCase } from "@src/utils/functions";
import { useMutation } from "@apollo/client";

let firebaseConfig = {
  apiKey: "AIzaSyC_5v7162QDclETxezrU9wT5tQfM780pU8",
  authDomain: "refurb-and-spares.firebaseapp.com",
  projectId: "refurb-and-spares",
  storageBucket: "refurb-and-spares.appspot.com",
  messagingSenderId: "549012201505",
  appId: "1:549012201505:web:530bffe397798234fe0360",
  measurementId: "G-2M9HH7BHB3",
};

let VAPID_KEY =
  "BOvGDkHnTh_rZTjhek-AjUfJSXKUPsvvhdoFYxHdFgjfVEQgJ12yvtY5iE3IKiy_zjhWGaj2Kc6HMplq2x0J4t4";

if (!IS_DEV_ENV) {
  firebaseConfig = {
    apiKey: "AIzaSyB82aC8R7VVRZLnn-qS8nltMqEsvS2sPCM",
    authDomain: "sp-refurbishment-notifications.firebaseapp.com",
    projectId: "sp-refurbishment-notifications",
    storageBucket: "sp-refurbishment-notifications.appspot.com",
    messagingSenderId: "29417633353",
    appId: "1:29417633353:web:e3dea13f3ed9af7b947198",
    measurementId: "G-349XJ8V3DN",
  };
  //sp-refurbishment
  VAPID_KEY =
    "BLnbDXyjfOmQR0oD0x2L6cAEWjQ6Z7tNWnc1m04kPrCCiON2lT3BSuuqWt2PPUDEMYZymt4Vw6T_wg_t8ibMCeo";
}

export const getDiffOfLastTokenSet = () => {
  let lastTokenSet = localStorage.getItem("fcm_last_set_timestamp");
  if (lastTokenSet) {
    const lastSetTimestamp = moment(JSON.parse(lastTokenSet));
    const currentTimeStamp = moment(new Date());
    const diffInDays = currentTimeStamp.diff(lastSetTimestamp, "days");
    return diffInDays;
  }
};

const getFCMToken = async (messaging) => {
  let fcmToken = await localStorage.getItem("fcm_token");
  if (fcmToken) return fcmToken;
  fcmToken = await getToken(messaging, {
    vapidKey: VAPID_KEY,
  });
  localStorage.setItem("fcm_token", fcmToken || "");
  return fcmToken;
};

function Notifications({ navigation, screenProps }) {
  let { notificationsRef, updateNotificationCount } = screenProps;
  const [notifications, setNotifications] = useState(
    notificationsRef.current ? notificationsRef.current : []
  );
  const [newNotification, setNewNotification] = useState<any>({});

  const [setFirebaseToken] = useMutation(SET_FIREBASE_TOKEN, {
    client: catClient,
    fetchPolicy: "network-only",
  });
  const [setFirebaseTokenForRefurb] = useMutation(SET_FIREBASE_TOKEN, {
    client: clientV2,
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (Object.keys(newNotification).length > 0) {
      if (notificationsRef.current === null) notificationsRef.current = [];
      let tempMessages = [...notificationsRef.current];
      tempMessages.push(newNotification);
      notificationsRef.current = tempMessages;
      setNotifications(notificationsRef.current);
      setTimeout(() => {
        notificationsRef.current = notificationsRef.current.filter(
          (notification) =>
            notification.messageId !== newNotification?.messageId
        );
        setNotifications(notificationsRef.current);
      }, 10000);
    }
  }, [newNotification]);

  const setTokenIntoDB = async () => {
    let fcmToken = localStorage.getItem("fcm_token");
    setFirebaseToken({ variables: { token: fcmToken } }).then(() => {
      const date = new Date();
      localStorage.setItem("fcm_last_set_timestamp", JSON.stringify(date));
    });
  };

  const setTokenIntoRefurbDB = async () => {
    let fcmToken = localStorage.getItem("fcm_token");
    setFirebaseTokenForRefurb({ variables: { token: fcmToken } }).then(() => {
      const date = new Date();
      localStorage.setItem("fcm_last_set_timestamp", JSON.stringify(date));
    });
  };

  const removeFirebaseToken = (token) => {
    const emptyData = () => {
      localStorage.removeItem("fcm_token");
      localStorage.removeItem("fcm_last_set_timestamp");
    };
    catClient
      .mutate({
        mutation: REMOVE_FIREBASE_TOKEN,
        variables: {
          token,
        },
      })
      .then((res) => {
        emptyData();
      })
      .catch(() => {
        emptyData();
      });
  };

  const removeFirebaseTokenFromRefurb = (token) => {
    const emptyData = () => {
      localStorage.removeItem("fcm_token");
      localStorage.removeItem("fcm_last_set_timestamp");
    };
    clientV2
      .mutate({
        mutation: REMOVE_FIREBASE_TOKEN,
        variables: {
          token,
        },
      })
      .then((res) => {
        emptyData();
      })
      .catch(() => {
        emptyData();
      });
  };

  const getNotificationCountCall = (type) => {
    countQuery()
      .then((res) => {
        updateNotificationCount(type, res?.data?.getNotificationCount);
      })
      .catch((err) => {
        console.log("errr count", err);
      });
  };

  const getNotificationCountCallForRefurb = (type) => {
    countQueryForRefurb()
      .then((res) => {
        updateNotificationCount(type, res?.data?.getNotificationCount);
      })
      .catch((err) => {
        console.log("errr count", err);
      });
  };

  const messageReceived = (message) => {
    console.log("Foreground message received:", message);
    let notificationData = message?.data;
    let context = JSON.parse(notificationData?.screen_with_context);
    if (context?.screen === "catalogue_active_alternate_part_requests")
      getNotificationCountCall("spare");
    else if (
      context?.screen === "warranty_inventory_view" ||
      context?.screen === "dashboard_job_list_view"
    )
      getNotificationCountCallForRefurb("refurb");
    else getNotificationCountCall("spare");
    setNewNotification(message);
  };

  useEffect(() => {
    const requestPermission = async () => {
      const permission = await Notification.requestPermission();
      let catToken = localStorage.getItem(CAT_TOKEN);
      let refurbToken = localStorage.getItem(REFURB_TOKEN);
      if (permission === "granted") {
        const app = initializeApp(firebaseConfig);
        const diffInDays = getDiffOfLastTokenSet();
        const messaging = getMessaging(app);

        onMessage(messaging, messageReceived);

        if (catToken) {
          try {
            const currentToken = await getFCMToken(messaging);
            if (diffInDays > 15 || diffInDays === undefined) setTokenIntoDB();
          } catch (err) {
            console.log("Some other error", err);
          }
        }
        if (refurbToken) {
          try {
            const currentToken = await getFCMToken(messaging);
            if (diffInDays > 15 || diffInDays === undefined)
              setTokenIntoRefurbDB();
          } catch (err) {
            console.log("Some other error", err);
          }
        }
      } else {
        console.log("Do not have permission!");
        let fcmToken = localStorage.getItem("fcm_token");
        if (fcmToken && catToken) removeFirebaseToken(fcmToken);
        if (fcmToken && refurbToken) removeFirebaseTokenFromRefurb(fcmToken);
      }
    };

    requestPermission();
  }, []);

  const onCrossPress = (messageId) => {
    notificationsRef.current = notificationsRef.current.filter(
      (notification) => notification.messageId !== messageId
    );
    setNotifications(notificationsRef.current);
  };

  const NotificationComponent = ({ notification, messageId }) => {
    let icon = null;
    let color = THEME_COLORS.bgWhite;
    let context = JSON.parse(notification?.screen_with_context);
    let reason = context?.reason_for_rejection;

    if (notification?.title === "Part punching request approved") {
      icon = (
        <MaterialCommunityIcons
          name={"check-circle"}
          size={18}
          color={"#009962"}
        />
      );
      color = "#009962";
    } else if (notification?.title === "Alternate part request received") {
      icon = (
        <MaterialCommunityIcons
          name={"account-arrow-left"}
          size={18}
          color={THEME_COLORS.bgWhite}
        />
      );
    } else if (notification?.title === "Part punching request rejected") {
      icon = (
        <MaterialCommunityIcons
          name={"close-circle"}
          size={18}
          color={THEME_COLORS.red}
        />
      );
      color = THEME_COLORS.red;
    } else if (notification?.title === "Part quantity has been reduced") {
      icon = (
        <MaterialCommunityIcons
          name="arrow-down-bold-circle"
          size={18}
          color={THEME_COLORS.red}
        />
      );
      color = "white";
    }

    const onViewDetailsClick = () => {
      onCrossPress(messageId);

      if (context?.screen === "catalogue_active_alternate_part_requests") {
        if (navigation?.state?.routeName === "CatalogueRequests")
          navigation?.setParams({
            alternatePartId: context?.alternate_part_request_id,
          });
        else
          navigation.navigate("CatalogueRequests", {
            alternatePartId: context?.alternate_part_request_id,
          });
      } else if (context?.screen === "warranty_inventory_view") {
        navigation.navigate("Warranty", { ticketId: context?.ticket_id });
      } else if (context?.screen === "dashboard_job_list_view") {
        navigation?.navigate?.("CarRefurbMetrics", {
          refurbCarId: context?.refurb_car_id,
          parent: "Warranty",
          params: navigation?.state?.params,
        });
      } else if (context?.screen === "document_details_for_resolution") {
        navigation.navigate("ResolutionManagementDetail", {
          documentId: context.document_id,
          documentType: context?.document_type,
          activeTab: undefined,
        });
      } else if (context?.screen === "document_details_for_approval") {
        navigation.navigate("DisputeManagementDetail", {
          documentId: context.document_id,
          documentType: context?.document_type,
          activeTab: undefined,
        });
      } else if (context?.screen === "warranty_comment_view") {
        navigation.navigate("CarRefurbMetrics", {
          refurbCarId: context?.refurb_car_id,
          ticketId: context?.ticket_id,
          openRemarks: true,
          parent: "Warranty",
          params: navigation?.state?.params,
        });
      } else if(context?.screen === 'issue_request_details') {
        navigation.navigate('SparesJobCardDetails', { requestId: context?.request_id })
      } else {
        let allParams = {
          breachedTAT: undefined,
          openMarket: undefined,
          liveTAT: undefined,
          status: undefined,
          brandId: undefined,
          brandName: undefined,
          vendorId: undefined,
          vendorName: undefined,
          search: "",
          refresh: true,
        };
        if (navigation?.state?.routeName === "Purchase")
          navigation?.setParams({
            batchId: context?.batch_item_id,
            tab: "part",
            ...allParams,
          });
        else
          navigation.navigate("Purchase", {
            batchId: context?.batch_item_id,
            tab: "part",
            ...allParams,
          });
        setTimeout(() => {
          navigation?.setParams?.({ refresh: undefined });
        }, 0);
      }
    };

    return (
      <View style={styles.notification}>
        <View>
          <View style={[styles.flexRow]}>
            <Text style={[styles.headingText, { color }]}>
              {notification?.title}
            </Text>
            {icon}
          </View>
          <Text style={styles.detailsText}>{notification?.subtext}</Text>
          <Text style={styles.detailsText}>
            {reason ? toCamelCase(reason?.replaceAll("_", " ")) : null}
          </Text>
        </View>
        <View style={[styles.flexRow, styles.viewDetailsCon]}>
          <Text onPress={onViewDetailsClick} style={styles.viewDetailsText}>
            View Details
          </Text>
          <TouchableOpacity onPress={() => onCrossPress(messageId)}>
            <MaterialCommunityIcons
              name={"close"}
              size={20}
              color={THEME_COLORS.bgWhite}
            />
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  return (
    <View style={styles.notificationCon}>
      <ScrollView showsVerticalScrollIndicator={false}>
        {notifications?.map((notification) => (
          <NotificationComponent
            key={notification.messageId}
            messageId={notification.messageId}
            notification={notification?.data}
          />
        ))}
      </ScrollView>
    </View>
  );
}

export default Notifications;

const styles = StyleSheet.create({
  notificationCon: {
    position: "absolute",
    top: "10vh",
    right: "5vw",
    zIndex: 10,
    height: "60vh",
  },
  flexRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  notification: {
    backgroundColor: "#303030",
    width: "30vw",
    marginBottom: 50,
    paddingVertical: 18,
    paddingHorizontal: 22,
    borderRadius: 5,
    justifyContent: "space-between",
  },
  headingText: {
    fontSize: 16,
    color: THEME_COLORS.bgWhite,
    fontFamily: FONT_FAMILY.mediumV3,
    marginRight: 6,
  },
  detailsText: {
    fontSize: 15,
    color: `${THEME_COLORS.bgWhite}80`,
    fontFamily: FONT_FAMILY.primaryV3,
    marginTop: 7,
  },
  viewDetailsText: {
    fontSize: 15,
    color: "#B180D1",
    fontFamily: FONT_FAMILY.mediumV3,
    marginRight: 15,
  },
  viewDetailsCon: {
    justifyContent: "flex-end",
    marginTop: 20,
  },
});
